module.exports = __webpack_public_path__ + "static/media/no-profile.1e179efe.png";